import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'


interface CommonState {
  isLMSUser: boolean | null
  isLoanExpired: boolean
  foreCloseReason: any,
  phoneNumber: string,
  isBFLLoan: boolean,
  // Add the index signature for dynamic properties
  [key: string]: any;  // This allows any new key with any value to be added
  isLoanCompleted: boolean
  isLMSUserDashboard: boolean
  referralBanner: any
  ltvUpgradeDetails: any
  failedRequestDetails: any
}



// Define the initial state using that type
const initialState: CommonState = {
  isLMSUser: null,
  isLoanExpired: false,
  foreCloseReason: {},
  phoneNumber: '',
  isBFLLoan: false,
  isLoanCompleted: false,
  isLMSUserDashboard: false,
  referralBanner: null,
  ltvUpgradeDetails: null,
  failedRequestDetails: null,
}

export const commonSlice = createSlice({
  name: 'commonDetails',
  initialState,
  reducers: {
    clearCommonStore: (state) => {
      state.isLMSUser = null;
      state.isLoanExpired = false;
      state.foreCloseReason = {};
      state.phoneNumber = '';
      state.isLoanCompleted = false;
      state.isLMSUserDashboard = false;
      state.referralBanner = null;
      state.ltvUpgradeDetails = null;
      state.failedRequestDetails = null;
      // Reset any other properties as needed
    },
    updateLoanExpiryState: (state, action: PayloadAction<Pick<CommonState, 'loanExpired'>>) => {
      state.isLoanExpired = action.payload.loanExpired;
    },
    updateForeCloseReason: (state, action: PayloadAction<Pick<CommonState, 'foreCloseReason'>>) => {
      state.foreCloseReason = action.payload;
    },
    updateisLMSUser: (state, action: PayloadAction<Pick<CommonState, 'isLMSUser'>>) => {
      state.isLMSUser = action.payload.isLMSUser;
    },
    updatePhoneNumber: (state, action: PayloadAction<Pick<CommonState, 'phoneNumber'>>) => {
      state.phoneNumber = action.payload.phoneNumber;
    },
    updateBFLCheck: (state, action: PayloadAction<Pick<CommonState, 'isBFLLoan'>>) => {
      state.isBFLLoan = action.payload.isBFLLoan;
    },
    updateIsLoanCompleted: (state, action: PayloadAction<Pick<CommonState, 'isLoanCompleted'>>) => {
      state.isLoanCompleted = action.payload.isLoanCompleted;
    },
    updateLMSUserDashboard: (state, action: PayloadAction<Pick<CommonState, 'isLMSUserDashboard'>>) => {
      state.isLMSUserDashboard = action.payload.isLMSUserDashboard;
    },
    updateReferralBanner: (state, action: PayloadAction<any>) => {
      state.referralBanner = action.payload;
    },
    updateLtvBanner: (state, action: PayloadAction<any>) => {
      state.ltvUpgradeDetails = action.payload;
    },
    updateFailedRequestDetails: (state, action: PayloadAction<any>) => {
      state.failedRequestDetails = action.payload;
    },
  },
});

export const { clearCommonStore, updateLoanExpiryState, updateForeCloseReason, updateisLMSUser, updatePhoneNumber, updateBFLCheck, updateIsLoanCompleted, updateLMSUserDashboard, updateReferralBanner, updateLtvBanner, updateFailedRequestDetails } = commonSlice.actions


export default commonSlice.reducer